<template>
  <div class="detail-container">
    <div class="status-container">
      <div>索赔单号：{{ claimantInfo.claimStatementNum }}</div>
      <div class="status">状态：{{ claimantInfo.auditResultDisplay }}</div>
      <span
        v-if="pageIndex === 'detail'"
        class="btn"
        @click="handleViewRecord('record')"
        >查看记录</span
      >
    </div>
    <div v-if="pageIndex === 'detail'" class="form_info">
      <el-form
        :inline="true"
        :model="claimantInfo"
        :rules="fieldsData"
        ref="form"
        label-width="160px"
      >
        <!-- 车辆基本信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            车辆基本信息
          </div>
        </div>
        <div class="form-container">
          <!-- VIN -->
          <el-form-item label="VIN" prop="vin">
            <el-select
              :disabled="getDisabledField('vin')"
              v-model="claimantInfo.vin"
              @change="changeVin"
              filterable
              clearable
              remote
              reserve-keyword
              placeholder=""
              :remote-method="vinRemoteMethod"
              :loading="loading"
            >
              <el-option
                v-for="item in vinOptions"
                :key="item.vin"
                :label="item.vin"
                :value="item.vin"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 品牌 -->
          <el-form-item label="品牌" prop="carBrand">
            <el-input
              :disabled="getDisabledField('carBrand')"
              v-model="claimantInfo.carBrand"
            ></el-input>
          </el-form-item>
          <!-- 车型 -->
          <el-form-item label="车型" prop="carModel">
            <el-input
              :disabled="getDisabledField('carModel')"
              v-model="claimantInfo.carModel"
            ></el-input>
          </el-form-item>
          <!-- 车辆属性 -->
          <el-form-item label="车辆属性" prop="carAttribute">
            <el-select
              :disabled="getDisabledField('carAttribute')"
              v-model="claimantInfo.carAttribute"
              filterable
              clearable
            >
              <el-option label="燃油车" :value="0"> </el-option>
              <el-option label="电动车" :value="1"> </el-option>
            </el-select>
          </el-form-item>
          <!-- 发动机号 -->
          <el-form-item
            label="发动机号"
            :prop="claimantInfo.carAttribute === 0 ? 'engineNumber' : ''"
          >
            <el-input
              :disabled="getDisabledField('engineNumber')"
              v-model="claimantInfo.engineNumber"
            ></el-input>
          </el-form-item>
          <!-- 发动机/电机型号 -->
          <el-form-item
            label="发动机/电机型号"
            :prop="claimantInfo.carAttribute === 0 ? 'engineModel' : ''"
          >
            <el-input
              :disabled="getDisabledField('engineModel')"
              v-model="claimantInfo.engineModel"
            ></el-input>
          </el-form-item>
          <!-- 电机号 -->
          <el-form-item
            label="电机号"
            :prop="claimantInfo.carAttribute === 1 ? 'motorModel' : ''"
          >
            <el-input
              :disabled="getDisabledField('motorModel')"
              v-model="claimantInfo.motorModel"
            ></el-input>
          </el-form-item>
          <!-- 行驶里程 -->
          <el-form-item label="行驶里程" prop="roadHaul">
            <el-input-number
              :disabled="getDisabledField('roadHaul')"
              class="number-input"
              :controls="false"
              :precision="0"
              v-model="claimantInfo.roadHaul"
              placeholder="请输入"
            ></el-input-number>
            <div class="number-input-append">km</div>
          </el-form-item>
          <!-- 生产日期 -->
          <el-form-item label="生产日期" prop="productionDate">
            <el-date-picker
              :disabled="getDisabledField('productionDate')"
              type="date"
              value-format="yyyy-MM-dd"
              v-model="claimantInfo.productionDate"
              style="width: 250px"
            ></el-date-picker>
          </el-form-item>
          <!-- 购车日期 -->
          <el-form-item label="购车日期" prop="salesDate">
            <el-date-picker
              :disabled="getDisabledField('salesDate')"
              type="date"
              value-format="yyyy-MM-dd"
              v-model="claimantInfo.salesDate"
              style="width: 250px"
            ></el-date-picker>
          </el-form-item>
          <!-- 国家 -->
          <el-form-item label="国家" prop="customerCountry">
            <el-select
              :disabled="getDisabledField('customerCountry')"
              filterable
              clearable
              v-model="claimantInfo.customerCountry"
              placeholder="请选择"
            >
              <el-option
                v-for="item in Object.values(getSession('nationList'))"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 客户账号 -->
          <el-form-item label="客户账号" prop="customerAccountNum">
            <el-input
              :disabled="getDisabledField('customerAccountNum')"
              v-model="claimantInfo.customerAccountNum"
            ></el-input>
          </el-form-item>
          <!-- 零部件专业 -->
          <el-form-item label="零部件专业" prop="lbjzy">
            <el-select
              :disabled="getDisabledField('lbjzy')"
              v-model="claimantInfo.lbjzy"
              filterable
              clearable
            >
              <el-option
                v-for="item in partMajorList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <!-- 车辆故障信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            车辆故障信息
          </div>
        </div>
        <div class="form-container">
          <!-- 发生日期 -->
          <el-form-item label="发生日期" prop="happenDate">
            <el-date-picker
              :disabled="getDisabledField('happenDate')"
              type="date"
              value-format="yyyy-MM-dd"
              v-model="claimantInfo.happenDate"
              style="width: 250px"
              @change="getPreSetData"
            ></el-date-picker>
          </el-form-item>
          <!-- 问题类别 -->
          <el-form-item label="问题类别" prop="questionType">
            <el-select
              v-model="claimantInfo.questionType"
              :disabled="getDisabledField('questionType')"
              filterable
              clearable
            >
              <el-option label="客户PDI" value="客户PDI"> </el-option>
              <el-option label="终端客户" value="终端客户"> </el-option>
              <el-option label="零部件质量" value="零部件质量"> </el-option>
              <el-option label="零部件差缺" value="零部件差缺"> </el-option>
              <el-option label="零部件运损" value="零部件运损"> </el-option>
              <el-option label="港口救援" value="港口救援"> </el-option>
            </el-select>
          </el-form-item>
          <!-- 维修方案 -->
          <!--          <el-form-item label="维修方案" prop="repairPlan">-->
          <!--            <el-select-->
          <!--              :disabled="getDisabledField('repairPlan')"-->
          <!--              v-model="claimantInfo.repairPlan"-->
          <!--              placeholder=""-->
          <!--              @change="changRepairPlan"-->
          <!--              filterable-->
          <!--              clearable-->
          <!--            >-->
          <!--              <el-option label="维修" :value="0"> </el-option>-->
          <!--              <el-option label="更换" :value="1"> </el-option>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <!-- 故障现象 -->
          <div class="fanyi-box">
            <el-form-item
              label="故障现象原文"
              prop="symptom"
              label-width="140px"
            >
              <el-input
                :disabled="getDisabledField('symptom')"
                type="textarea"
                v-model="claimantInfo.symptom"
                style="width: 670px"
              ></el-input>
            </el-form-item>
            <!--            <el-form-item>-->
            <!--              <translate-->
            <!--                style="margin-top: 30px; padding-left: 10px"-->
            <!--                :content="claimantInfo.symptom"-->
            <!--                field="symptomCn"-->
            <!--                @getTranslateVal="getTranslateVal"-->
            <!--              />-->
            <!--            </el-form-item>-->
            <br />
            <el-form-item label="故障现象" prop="symptomCn" label-width="140px">
              <el-input
                :disabled="getDisabledField('symptomCn')"
                type="textarea"
                v-model="claimantInfo.symptomCn"
                style="width: 670px"
              ></el-input>
            </el-form-item>
          </div>

          <!-- 故障初步原因 -->
          <div class="fanyi-box">
            <el-form-item
              label="故障初步原因原文"
              prop="preliminaryCauseOfFailure"
              label-width="140px"
            >
              <el-input
                :disabled="getDisabledField('preliminaryCauseOfFailure')"
                type="textarea"
                v-model="claimantInfo.preliminaryCauseOfFailure"
                style="width: 670px"
              ></el-input>
            </el-form-item>
            <!--            <el-form-item>-->
            <!--              <translate-->
            <!--                style="margin-top: 30px; padding-left: 10px"-->
            <!--                :content="claimantInfo.preliminaryCauseOfFailure"-->
            <!--                field="preliminaryCauseOfFailureCn"-->
            <!--                @getTranslateVal="getTranslateVal"-->
            <!--              />-->
            <!--            </el-form-item>-->
            <br />
            <el-form-item
              label="故障初步原因"
              prop="preliminaryCauseOfFailureCn"
              label-width="140px"
            >
              <el-input
                :disabled="getDisabledField('preliminaryCauseOfFailureCn')"
                type="textarea"
                v-model="claimantInfo.preliminaryCauseOfFailureCn"
                style="width: 670px"
              ></el-input>
            </el-form-item>
          </div>
          <!-- 故障处理方案 -->
          <div class="fanyi-box">
            <el-form-item
              label="故障处理方案原文"
              prop="processingScenarios"
              label-width="140px"
            >
              <el-input
                :disabled="getDisabledField('processingScenarios')"
                type="textarea"
                v-model="claimantInfo.processingScenarios"
                style="width: 670px"
              ></el-input>
            </el-form-item>
            <br />
            <el-form-item
              label="故障处理方案"
              prop="processingScenariosCn"
              label-width="140px"
            >
              <el-input
                :disabled="getDisabledField('processingScenariosCn')"
                type="textarea"
                v-model="claimantInfo.processingScenariosCn"
                style="width: 670px"
              ></el-input>
            </el-form-item>
            <br />
            <el-form-item label="翻译" label-width="140px">
              <translate-all
                :contents="[
                  claimantInfo.processingScenarios,
                  claimantInfo.symptom,
                  claimantInfo.preliminaryCauseOfFailure,
                ]"
                :fields="[
                  'processingScenariosCn',
                  'symptomCn',
                  'preliminaryCauseOfFailureCn',
                ]"
                @getTranslateVal="getTranslateVal"
              />
            </el-form-item>
          </div>
        </div>
        <!-- 故障件信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            故障件信息
          </div>
        </div>
        <!-- 主因故障件 -->
        <div class="second-title">主因故障件</div>
        <div class="form-container">
          <!-- 故障件件号 -->
          <el-form-item
            class="err-nowarp"
            label="故障件件号"
            prop="faultPartNumber"
          >
            <el-autocomplete
              :disabled="getDisabledField('faultPartNumber')"
              ref="autocomplete"
              v-model="claimantInfo.faultPartNumber"
              placeholder="请输入"
              :fetch-suggestions="getFaultList"
              @select="handleSelect($event)"
              @keyup.enter.native="handleInput('autocomplete')"
              @blur="onBlurFault()"
            ></el-autocomplete>
          </el-form-item>
          <!-- 故障件名称 -->
          <el-form-item label="故障件名称" prop="faultPartNameZh">
            <el-input
              :disabled="getDisabledField('faultPartNameZh')"
              v-model="claimantInfo.faultPartNameZh"
            ></el-input>
          </el-form-item>
          <!-- 故障件单价 -->
          <el-form-item label="故障件单价" prop="faultPartUnitPrice">
            <el-input-number
              :disabled="!getDisabledField('faultPartUnitPrice')"
              class="prepend-padding number-input"
              v-model="claimantInfo.faultPartUnitPrice"
              :controls="false"
              :precision="2"
              @change="getTotalPrice('fault')"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 管理费费率 -->
          <el-form-item label="管理费费率" prop="managementFeeRate">
            <el-input-number
              :disabled="!getDisabledField('managementFeeRate')"
              v-model="claimantInfo.managementFeeRate"
              @change="getTotalPrice('fault')"
              :controls="false"
              class="number-input"
              :precision="3"
            ></el-input-number>
          </el-form-item>
          <!-- 更换数量 -->
          <el-form-item label="更换数量" prop="changeQuantity">
            <el-input-number
              :controls="false"
              :precision="0"
              v-model="claimantInfo.changeQuantity"
              class="number-input"
              placeholder="请输入"
              @change="getTotalPrice('fault')"
            ></el-input-number>
          </el-form-item>
          <!-- 维修方案 -->
          <el-form-item label="维修方案" prop="repairPlan">
            <el-select
              v-model="claimantInfo.repairPlan"
              :disabled="$route.query.operate !== '审核'"
              placeholder=""
              @change="changRepairPlan"
              filterable
              clearable
            >
              <el-option label="维修" :value="0"> </el-option>
              <el-option label="更换" :value="1"> </el-option>
              <el-option label="补发" :value="2"> </el-option>
            </el-select>
          </el-form-item>
          <!-- 工时 -->
          <el-form-item label="工时(h)" prop="workingHours">
            <el-input-number
              v-model="claimantInfo.workingHours"
              :controls="false"
              :min="0"
              :max="999"
              :precision="2"
              class="number-input"
              @change="getTotalPrice('fault')"
            ></el-input-number>
          </el-form-item>
          <!-- 运费 -->
          <el-form-item label="运费" prop="shippingFee">
            <el-input-number
              v-model="claimantInfo.shippingFee"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
              @change="getTotalPrice('fault')"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 关税 -->
          <el-form-item label="关税" prop="tariff">
            <el-input-number
              v-model="claimantInfo.tariff"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
              @change="getTotalPrice('fault')"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 差旅费 -->
          <el-form-item label="差旅费" prop="travelPrice">
            <el-input-number
              v-model="claimantInfo.travelPrice"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
              @change="getTotalPrice('fault')"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 其他费用 -->
          <el-form-item label="其他费用" prop="otherExpenses">
            <el-input-number
              v-model="claimantInfo.otherExpenses"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
              @change="getTotalPrice('fault')"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>

          <!-- 工时费用 -->
          <el-form-item label="工时费用" prop="laborCost">
            <el-input-number
              :disabled="getDisabledField('laborCost')"
              v-model="claimantInfo.laborCost"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
              @change="getTotalPrice('onlyWork')"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 材料费用 -->
          <el-form-item label="材料费用" prop="materialCost">
            <el-input-number
              :disabled="getDisabledField('materialCost')"
              v-model="claimantInfo.materialCost"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 故障件总金额 -->
          <el-form-item label="故障件总金额" prop="faultPartTotalPrice">
            <el-input-number
              :disabled="
                getDisabledField('faultPartTotalPrice') ||
                claimantInfo.repairPlan == 0
              "
              v-model="claimantInfo.faultPartTotalPrice"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 零部件来源 -->
          <el-form-item label="零部件来源" prop="sourceOfComponents">
            <el-select
              v-model="claimantInfo.sourceOfComponents"
              placeholder=""
              @change="getTotalPrice('fault')"
              filterable
              clearable
            >
              <el-option label="海外免费件" :value="0"> </el-option>
              <el-option label="供应商免费件" :value="2"> </el-option>
              <el-option label="收费件" :value="1"> </el-option>
            </el-select>
          </el-form-item>
          <!-- 其他故障件 -->
        </div>
        <div class="second-title" v-if="showfaultListError">
          其他故障件
          <div
            v-if="showfaultListError"
            class="is-error"
            style="margin-left: 37px"
          >
            提示：当前故障件暂时无法索赔，请联系所在地区服务经理进行维护
          </div>
        </div>
        <div class="table-container" style="padding: 15px 18px 0 54px">
          <el-table :data="claimantInfo.faultPartsList" border>
            <!-- 序号 -->
            <el-table-column
              type="index"
              label="序号"
              width="60"
              align="center"
            >
            </el-table-column>
            <!-- 故障件件号 -->
            <el-table-column
              prop="faultPartNumber"
              label="故障件件号"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <span v-if="getDisabledField('faultPartNumber')">
                  {{ scope.row.faultPartNumber }}
                </span>
                <div v-else>
                  <el-autocomplete
                    :class="
                      scope.row.error
                        ? 'is-error table-auto-input'
                        : 'table-auto-input'
                    "
                    :ref="'autocomplete' + scope.$index"
                    v-model="scope.row.faultPartNumber"
                    placeholder="请输入"
                    :fetch-suggestions="getFaultList"
                    @select="handleSelect($event, scope.$index)"
                    @keyup.enter.native="
                      handleInput('autocomplete' + scope.$index)
                    "
                    @blur="onBlurFault(scope.$index)"
                  ></el-autocomplete>
                </div>
              </template>
            </el-table-column>
            <!-- 故障件名称 -->
            <el-table-column
              prop="faultPartNameZh"
              label="故障件名称"
              align="center"
              min-width="160px"
            >
            </el-table-column>
            <!-- 故障件单价 -->
            <el-table-column
              prop="faultPartUnitPrice"
              label="故障件单价"
              align="center"
              min-width="120px"
            >
              <template slot-scope="scope">
                <div>
                  <span v-if="getDisabledField('faultPartUnitPrice')">
                    {{ claimantInfo.currency === 0 ? "￥" : "" }}
                    {{ claimantInfo.currency === 1 ? "$" : "" }}
                    {{ scope.row.faultPartUnitPrice }}
                  </span>
                  <div v-else>
                    <div
                      style="
                        position: relative;
                        width: fit-content;
                      "
                    >
                      <el-input-number
                        :controls="false"
                        :precision="2"
                        @change="getTotalPrice('fault', scope.$index)"
                        v-model="scope.row.faultPartUnitPrice"
                        class="prepend-padding number-input"
                      ></el-input-number>
                      <div class="number-input-prepend">
                        {{ claimantInfo.currency === 0 ? "￥" : "" }}
                        {{ claimantInfo.currency === 1 ? "$" : "" }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 更换数量 -->
            <el-table-column
              prop="changeQuantity"
              label="更换数量"
              align="center"
              min-width="100px"
            >
              <template slot-scope="scope">
                <span v-if="getDisabledField('changeQuantity')">
                  {{ scope.row.changeQuantity }}
                </span>
                <el-input-number
                  v-else
                  :disabled="
                    claimantInfo.repairPlan == 0 &&
                    $route.query.operate !== '审核'
                  "
                  :controls="false"
                  :precision="0"
                  class="number-input"
                  v-model="scope.row.changeQuantity"
                  placeholder="请输入"
                  @change="getTotalPrice('fault', scope.$index)"
                ></el-input-number>
              </template>
            </el-table-column>
            <!-- 维修方案 -->
            <el-table-column
              prop="repairPlan"
              label="维修方案"
              align="center"
              min-width="100px"
            >
              <template slot-scope="scope">
                <span v-if="getDisabledField('repairPlan')">
                  {{ scope.row.repairPlan === 0 ? "维修" : "" }}
                  {{ scope.row.repairPlan === 1 ? "更换" : "" }}
                  {{ scope.row.repairPlan === 2 ? "补发" : "" }}
                </span>
                <el-select
                  v-else
                  :disabled="
                    claimantInfo.repairPlan == 0 &&
                    $route.query.operate !== '审核'
                  "
                  v-model="scope.row.repairPlan"
                  @change="getTotalPrice('fault', scope.$index)"
                  filterable
                  clearable
                >
                  <el-option label="维修" :value="0"> </el-option>
                  <el-option label="更换" :value="1"> </el-option>
                  <el-option label="补发" :value="2"> </el-option>
                </el-select>
              </template>
            </el-table-column>
            <!-- 工时 -->
            <el-table-column
              prop="workingHours"
              label="工时(h)"
              align="center"
              min-width="100px"
            >
              <template slot-scope="scope">
                <span v-if="!getDisabledField('workingHours')">
                  {{ scope.row.workingHours }}
                </span>
                <el-input-number
                  v-else
                  :disabled="
                    claimantInfo.repairPlan == 0 &&
                    $route.query.operate !== '审核'
                  "
                  :controls="false"
                  :precision="2"
                  :min="0"
                  :max="999"
                  class="number-input"
                  v-model="scope.row.workingHours"
                  placeholder="请输入"
                  @change="getTotalPrice('fault', scope.$index)"
                ></el-input-number>
              </template>
            </el-table-column>
            <!-- 运费 -->
            <el-table-column
              prop="shippingFee"
              label="运费"
              align="center"
              min-width="100px"
            >
              <template slot-scope="scope">
                <span v-if="!getDisabledField('shippingFee')">
                  {{ claimantInfo.currency === 0 ? "￥" : "" }}
                  {{ claimantInfo.currency === 1 ? "$" : "" }}
                  {{ scope.row.shippingFee }}
                </span>
                <div v-else>
                  <div
                    style="
                      position: relative;
                      width: fit-content;
                    "
                  >
                    <el-input-number
                      :controls="false"
                      :precision="2"
                      @change="getTotalPrice('fault', scope.$index)"
                      v-model="scope.row.shippingFee"
                      class="prepend-padding number-input"
                    ></el-input-number>
                    <div class="number-input-prepend">
                      {{ claimantInfo.currency === 0 ? "￥" : "" }}
                      {{ claimantInfo.currency === 1 ? "$" : "" }}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 关税 -->
            <el-table-column
              prop="tariff"
              label="关税"
              align="center"
              min-width="100px"
            >
              <template slot-scope="scope">
                <span v-if="!getDisabledField('tariff')">
                  {{ claimantInfo.currency === 0 ? "￥" : "" }}
                  {{ claimantInfo.currency === 1 ? "$" : "" }}
                  {{ scope.row.tariff }}
                </span>
                <div v-else>
                  <div
                    style="
                      position: relative;
                      width: fit-content;
                    "
                  >
                    <el-input-number
                      :controls="false"
                      :precision="2"
                      @change="getTotalPrice('fault', scope.$index)"
                      v-model="scope.row.tariff"
                      class="prepend-padding number-input"
                    ></el-input-number>
                    <div class="number-input-prepend">
                      {{ claimantInfo.currency === 0 ? "￥" : "" }}
                      {{ claimantInfo.currency === 1 ? "$" : "" }}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>

            <!-- 差旅费 -->
            <el-table-column
              prop="travelPrice"
              label="差旅费"
              align="center"
              min-width="100px"
            >
              <template slot-scope="scope">
                <span v-if="getDisabledField('travelPrice')">
                  {{ claimantInfo.currency === 0 ? "￥" : "" }}
                  {{ claimantInfo.currency === 1 ? "$" : "" }}
                  {{ scope.row.travelPrice }}
                </span>
                <div v-else>
                  <div
                    style="
                      position: relative;
                      width: fit-content;
                    "
                  >
                    <el-input-number
                      :controls="false"
                      :precision="2"
                      @change="getTotalPrice('fault', scope.$index)"
                      v-model="scope.row.travelPrice"
                      class="prepend-padding number-input"
                    ></el-input-number>
                    <div class="number-input-prepend">
                      {{ claimantInfo.currency === 0 ? "￥" : "" }}
                      {{ claimantInfo.currency === 1 ? "$" : "" }}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>

            <!-- 其他费用 -->
            <el-table-column
              prop="otherExpenses"
              label="其他费用"
              align="center"
              min-width="100px"
            >
              <template slot-scope="scope">
                <span v-if="!getDisabledField('otherExpenses')">
                  {{ claimantInfo.currency === 0 ? "￥" : "" }}
                  {{ claimantInfo.currency === 1 ? "$" : "" }}
                  {{ scope.row.otherExpenses }}
                </span>
                <div v-else>
                  <div
                    style="
                      position: relative;
                      width: fit-content;
                    "
                  >
                    <el-input-number
                      :controls="false"
                      :precision="2"
                      @change="getTotalPrice('fault', scope.$index)"
                      v-model="scope.row.otherExpenses"
                      class="prepend-padding number-input"
                    ></el-input-number>
                    <div class="number-input-prepend">
                      {{ claimantInfo.currency === 0 ? "￥" : "" }}
                      {{ claimantInfo.currency === 1 ? "$" : "" }}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 管理费费率 -->
            <el-table-column
              prop="managementFeeRate"
              label="管理费费率"
              align="center"
              min-width="100px"
            >
              <template slot-scope="scope">
                <span v-if="!getDisabledField('managementFeeRate')">
                  {{ scope.row.managementFeeRate }}
                </span>
                <el-input-number
                  :controls="false"
                  :precision="3"
                  v-else
                  @change="getTotalPrice('fault', scope.$index)"
                  v-model="scope.row.managementFeeRate"
                ></el-input-number>
              </template>
            </el-table-column>
            <!-- 工时费用 -->
            <el-table-column
              prop="laborCost"
              label="工时费用"
              align="center"
              min-width="100px"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimantInfo.currency === 0 ? "￥" : "" }}
                  {{ claimantInfo.currency === 1 ? "$" : "" }}
                  {{ scope.row.laborCost }}
                </div>
              </template>
            </el-table-column>
            <!-- 材料费用 -->
            <el-table-column
              prop="materialCost"
              label="材料费用"
              align="center"
              min-width="100px"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimantInfo.currency === 0 ? "￥" : "" }}
                  {{ claimantInfo.currency === 1 ? "$" : "" }}
                  {{ scope.row.materialCost }}
                </div>
              </template>
            </el-table-column>
            <!-- 故障件总金额 -->
            <el-table-column
              prop="faultPartTotalPrice"
              label="故障件总金额"
              align="center"
              min-width="120px"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimantInfo.currency === 0 ? "￥" : "" }}
                  {{ claimantInfo.currency === 1 ? "$" : "" }}
                  {{ scope.row.faultPartTotalPrice }}
                </div>
              </template>
            </el-table-column>
            <!-- 零部件来源 -->
            <el-table-column
              prop="sourceOfComponents"
              label="零部件来源"
              align="center"
              min-width="120px"
            >
              <template slot-scope="scope">
                <span v-if="getDisabledField('sourceOfComponents')">
                  {{ scope.row.sourceOfComponents === 0 ? "海外免费件" : "" }}
                  {{ scope.row.sourceOfComponents === 1 ? "收费件" : "" }}
                  {{ scope.row.sourceOfComponents === 2 ? "供应商免费件" : "" }}
                </span>
                <el-select
                  v-else
                  :disabled="
                    claimantInfo.repairPlan == 0 &&
                    $route.query.operate !== '审核'
                  "
                  v-model="scope.row.sourceOfComponents"
                  @change="getTotalPrice('fault', scope.$index)"
                  filterable
                  clearable
                >
                  <el-option label="海外免费件" :value="0"> </el-option>
                  <el-option label="供应商免费件" :value="2"> </el-option>
                  <el-option label="收费件" :value="1"> </el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 费用信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            费用信息
          </div>
        </div>
        <div class="form-container">
          <!-- 总工时 -->
          <el-form-item label="总工时(h)" prop="manHour">
            <el-input-number
              :disabled="!getDisabledField('manHour')"
              v-model="claimantInfo.manHour"
              :controls="false"
              :min="0"
              :max="999"
              :precision="2"
              :placeholder="getDisabledField('manHour') ? '' : '请输入'"
              @change="getTotalPrice('costOfWork')"
            ></el-input-number>
          </el-form-item>
          <!-- 工时单价 -->
          <el-form-item label="工时单价" prop="hourlyRate">
            <el-input-number
              :disabled="!getDisabledField('hourlyRate')"
              v-model="claimantInfo.hourlyRate"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
              @change="getTotalPrice('costOfWork')"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 工时总费用 -->
          <el-form-item label="工时总费用" prop="totalCostOfWork">
            <el-input-number
              :disabled="getDisabledField('totalCostOfWork')"
              v-model="claimantInfo.totalCostOfWork"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 材料总费用 -->
          <el-form-item label="材料总费用" prop="materialTotalCost">
            <el-input-number
              :disabled="getDisabledField('materialTotalCost')"
              v-model="claimantInfo.materialTotalCost"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>

          <!-- 总运费 -->
          <el-form-item label="总运费" prop="freight">
            <el-input-number
              :disabled="!getDisabledField('freight')"
              v-model="claimantInfo.freight"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
              :placeholder="getDisabledField('freight') ? '' : '请输入'"
              @change="getTotalPrice('costOfWork')"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 总关税 -->
          <el-form-item label="总关税" prop="tariffTotal">
            <el-input-number
              :disabled="getDisabledField('tariffTotal')"
              v-model="claimantInfo.tariffTotal"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
              :placeholder="getDisabledField('tariffTotal') ? '' : '请输入'"
              @change="getTotalPrice('costOfWork')"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 其他总费用 -->
          <el-form-item label="其他总费用" prop="otherTotalCost">
            <el-input-number
              :disabled="!getDisabledField('otherTotalCost')"
              v-model="claimantInfo.otherTotalCost"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
              :placeholder="getDisabledField('otherTotalCost') ? '' : '请输入'"
              @change="getTotalPrice('costOfWork')"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 总差旅费 -->
          <el-form-item label="总差旅费" prop="travelPriceTotal">
            <el-input-number
              :disabled="getDisabledField('travelPriceTotal')"
              v-model="claimantInfo.travelPriceTotal"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
              placeholder="请输入"
              @change="getTotalPrice('costOfWork')"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <br />
          <!-- 其他费用说明 -->
          <el-form-item label="其他费用说明原文" prop="otherInstruction">
            <el-input
              :disabled="getDisabledField('otherInstruction')"
              v-model="claimantInfo.otherInstruction"
            ></el-input>
          </el-form-item>
          <el-form-item label=" " label-width="60px">
            <translate
              :content="claimantInfo.otherInstruction"
              field="otherInstructionZh"
              @getTranslateVal="getTranslateVal"
            />
          </el-form-item>
          <br />
          <el-form-item label="其他费用说明" prop="otherInstructionZh">
            <el-input
              :disabled="getDisabledField('otherInstructionZh')"
              v-model="claimantInfo.otherInstructionZh"
            ></el-input>
          </el-form-item>
          <el-form-item
            label=" "
            v-show="claimantInfo.auditResultDisplay == '待正审'"
            label-width="60px"
          >
            <translate
              :content="claimantInfo.otherInstructionZh"
              field="otherInstruction"
              from="zh-CHS"
              to="en"
              @getTranslateVal="getTranslateVal"
            />
          </el-form-item>
          <br />
          <!-- 索赔总费用 -->
          <el-form-item label="索赔总费用" prop="claimTotalCost">
            <el-input-number
              :disabled="getDisabledField('claimTotalCost')"
              v-model="claimantInfo.claimTotalCost"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimantInfo.currency === 0 ? "￥" : "" }}
              {{ claimantInfo.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 结算币种 -->
          <el-form-item label="结算币种" prop="currency">
            <el-select
              :disabled="getDisabledField('currency')"
              v-model="claimantInfo.currency"
              placeholder=""
              filterable
              clearable
            >
              <el-option label="CNY" :value="0"> </el-option>
              <el-option label="USD" :value="1"> </el-option>
            </el-select>
          </el-form-item>
        </div>
        <!-- 责任判定 -->
        <div
          v-if="
            !(
              $route.query.operate == '查看详情' &&
              claimantInfo.auditResultDisplay == '待正审'
            )
          "
          class="hearder-title"
        >
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            责任判定
            <span
              @click="handleHistoryResponsibility()"
              style="
                text-decoration: underline;
                cursor: pointer;
                margin-left: 10px;
                padding: 0px;
                color: var(--theme-color);
              "
              >历史判定</span
            >
            <history-responsibility-dialog
              ref="historyResponsibilityDialog"
              :responsibilityTypeList="responsibilityTypeList"
            />
          </div>
        </div>
        <div
          v-if="
            !(
              $route.query.operate == '查看详情' &&
              claimantInfo.auditResultDisplay == '待正审'
            )
          "
          class="table-container"
          style="padding: 15px 18px 0 54px"
        >
          <div
            v-if="
              claimantInfo.auditResultDisplay == '待正审' ||
              $route.query.operate == '编辑金额' ||
              ($route.query.operate == '审核' &&
                (claimantInfo.auditResultDisplay == '驳回(责任确定)' ||
                  claimantInfo.auditResultDisplay == '驳回(部长加签审批)' ||
                  claimantInfo.auditResultDisplay == '待确认(责任主体)')) ||
              ($route.query.operate == '责任确定' &&
                claimantInfo.auditResultDisplay == '待确认(责任主体)')
            "
            class="table-btn"
          >
            <el-button
              type="text"
              class="primary-btn"
              size="small"
              icon="el-icon-plus"
              @click="handleAddResponsibility"
              >添加责任主主体</el-button
            >
          </div>
          <el-table :data="claimantInfo.responsibilityPartList" border stripe>
            <!-- 序号 -->
            <el-table-column
              type="index"
              label="序号"
              width="60"
              align="center"
            >
            </el-table-column>
            <!-- 责任类型 -->
            <el-table-column
              prop="responsibilityType"
              label="责任类型"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div
                  v-if="
                    claimantInfo.auditResultDisplay == '待正审' ||
                    $route.query.operate == '责任确定' ||
                    $route.query.operate == '编辑金额' ||
                    ($route.query.operate == '审核' &&
                      (claimantInfo.auditResultDisplay == '驳回(责任确定)' ||
                        claimantInfo.auditResultDisplay ==
                          '驳回(部长加签审批)'))
                  "
                >
                  <el-select
                    v-model="scope.row.responsibilityType"
                    @change="responsibilityTypeChange(scope.row, scope.$index)"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="(item, index) in responsibilityTypeList"
                      :key="index"
                      :label="item.value"
                      :value="Number(item.codeText)"
                    >
                    </el-option>
                  </el-select>
                </div>

                <span v-else>{{
                  getDictValueByCodeText(
                    responsibilityTypeList,
                    scope.row.responsibilityType
                  )
                }}</span>
              </template>
            </el-table-column>
            <!-- 责任部门 -->
            <el-table-column
              prop="responsibilityDepartment"
              label="责任部门"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div
                  v-if="
                    claimantInfo.auditResultDisplay == '待正审' ||
                    $route.query.operate == '责任确定' ||
                    $route.query.operate == '编辑金额' ||
                    ($route.query.operate == '审核' &&
                      (claimantInfo.auditResultDisplay == '驳回(责任确定)' ||
                        claimantInfo.auditResultDisplay ==
                          '驳回(部长加签审批)'))
                  "
                >
                  <el-select
                    v-model="scope.row.responsibilityDepartment"
                    @change="
                      responsibilityDepartmentChange(scope.row, scope.$index)
                    "
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="(item, index) in responsibilityDepartmentListObj[
                        `responsibilityPart${scope.row.responsibilityType}`
                      ]"
                      :key="index"
                      :label="item.value"
                      :value="item.codeText"
                    >
                    </el-option>
                  </el-select>
                </div>

                <span v-else>{{ scope.row.responsibilityDepartment }}</span>
              </template>
            </el-table-column>
            <!-- 故障件件号 -->
            <el-table-column
              prop="faultPartNumber"
              label="故障件件号"
              align="center"
              min-width="220px"
            >
              <template slot-scope="scope">
                <div
                  v-if="
                    claimantInfo.auditResultDisplay == '待正审' ||
                    $route.query.operate == '责任确定' ||
                    $route.query.operate == '编辑金额' ||
                    ($route.query.operate == '审核' &&
                      (claimantInfo.auditResultDisplay == '驳回(责任确定)' ||
                        claimantInfo.auditResultDisplay ==
                          '驳回(部长加签审批)'))
                  "
                >
                  <el-select
                    v-model="scope.row.faultPartNumber"
                    placeholder="请选择"
                    @change="
                      responsibilityPartNumberChange(scope.row, scope.$index)
                    "
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="(item, index) in [
                        ...claimantInfo.faultPartsList,
                        {
                          faultPartNumber: claimantInfo.faultPartNumber,
                          faultPartName: claimantInfo.faultPartNameZh,
                        },
                      ]"
                      :key="index"
                      :label="item.faultPartNumber"
                      :value="item.faultPartNumber"
                    >
                    </el-option>
                  </el-select>
                </div>

                <span v-else>
                  {{ scope.row.faultPartNumber || "--" }}
                </span>
              </template>
            </el-table-column>
            <!-- 供应商代码 -->
            <el-table-column
              prop="responsibilitySupplierCode"
              label="供应商代码"
              align="center"
              min-width="220px"
            >
              <template slot-scope="scope">
                <div
                  v-if="
                    (claimantInfo.auditResultDisplay == '待正审' ||
                      $route.query.operate == '责任确定' ||
                      $route.query.operate == '编辑金额' ||
                      ($route.query.operate == '审核' &&
                        (claimantInfo.auditResultDisplay == '驳回(责任确定)' ||
                          claimantInfo.auditResultDisplay ==
                            '驳回(部长加签审批)'))) &&
                    scope.row.responsibilityDepartment === '供应商'
                  "
                >
                  <el-select
                    v-model="scope.row.responsibilitySupplierCode"
                    placeholder="请选择或输入"
                    allow-create
                    default-first-option
                    filterable
                    clearable
                    @change="
                      responsibilitySupplierCodeChange(scope.row, scope.$index)
                    "
                    @blur="handleSupplierCodeBlur(scope.row, scope.$index)"
                  >
                    <el-option
                      v-for="(item, index) in supplierList[scope.$index]"
                      :key="index"
                      :label="item.lifnr"
                      :value="item.lifnr"
                    >
                    </el-option>
                  </el-select>
                </div>

                <span v-else>
                  {{
                    scope.row.responsibilityDepartment === "供应商"
                      ? scope.row.responsibilitySupplierCode
                      : "--"
                  }}
                </span>
              </template>
            </el-table-column>
            <!-- 供应商名称 -->
            <el-table-column
              prop="responsibilitySupplier"
              label="供应商名称"
              align="center"
              min-width="220px"
            >
              <template slot-scope="scope">
                <!-- 如果当前供应商代码是手动输入的（即不在下拉列表中），则显示输入框 -->
                <div
                  v-if="
                    isManualSupplierCode(
                      scope.row.responsibilitySupplierCode,
                      scope.$index
                    )
                  "
                >
                  <el-input
                    v-model="scope.row.responsibilitySupplier"
                    placeholder="请手动输入供应商名称"
                  ></el-input>
                </div>

                <!-- 否则，显示自动填充或已存在的名称 -->
                <span v-else>
                  {{ scope.row.responsibilitySupplier || "--" }}
                </span>
              </template>
            </el-table-column>
            <!-- 故障件采购价 -->
            <el-table-column
              prop="responsibilityPurchasePrice"
              label="故障件采购价"
              align="center"
              min-width="220px"
            >
              <template slot-scope="scope">
                <!-- 如果当前供应商代码是手动输入的（即不在下拉列表中），则显示输入框 -->
                <div
                  v-if="
                    isManualSupplierCode(
                      scope.row.responsibilitySupplierCode,
                      scope.$index
                    )
                  "
                >
                  <el-input
                    v-model="scope.row.sapPrice"
                    type="number"
                    placeholder="请手动输入故障件采购价"
                  ></el-input>
                </div>

                <!-- 否则，显示自动填充或已存在的名称 -->
                <span v-else>
                  {{ scope.row.sapPrice || "--" }}
                </span>
              </template>
            </el-table-column>
            <!-- 责任占比 -->
            <el-table-column
              prop="responsibilityRatio"
              label="责任占比"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div
                  style="position: relative"
                  v-if="
                    claimantInfo.auditResultDisplay == '待正审' ||
                    $route.query.operate == '责任确定' ||
                    $route.query.operate == '编辑金额' ||
                    ($route.query.operate == '审核' &&
                      (claimantInfo.auditResultDisplay == '驳回(责任确定)' ||
                        claimantInfo.auditResultDisplay ==
                          '驳回(部长加签审批)'))
                  "
                >
                  <el-input-number
                    class="number-input"
                    v-model="scope.row.responsibilityRatio"
                    :controls="false"
                    :precision="2"
                    placeholder="请输入"
                  ></el-input-number>
                  <div class="number-input-append">%</div>
                </div>
                <span v-else>{{ scope.row.responsibilityRatio }}%</span>
              </template>
            </el-table-column>
            <!-- 货币单位 -->
            <el-table-column
              prop="currency"
              label="货币单位"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                {{ scope.row.currency === 0 ? "CNY" : "USD" }}
              </template>
            </el-table-column>
            <!-- 二赔金额 -->
            <el-table-column
              prop="secondDamages"
              label="二赔金额"
              align="center"
              min-width="160px"
              v-if="
                claimantInfo.auditResultDisplay == '待结算' ||
                claimantInfo.auditResultDisplay == '已结算' ||
                $route.query.operate === '编辑金额'
              "
            >
              <template slot-scope="scope">
                <el-input-number
                  v-if="
                    ($route.query.operate === '确认金额' ||
                      $route.query.operate === '编辑金额') &&
                    scope.row.responsibilityDepartment === '供应商'
                  "
                  v-model="scope.row.secondDamages"
                  :controls="false"
                  :precision="2"
                  placeholder="请输入"
                ></el-input-number>
                <span v-else>
                  {{
                    scope.row.secondDamages || scope.row.secondDamages === 0
                      ? "¥"
                      : ""
                  }}{{ scope.row.secondDamages }}
                </span>
              </template>
            </el-table-column>
            <!-- 责任说明 -->
            <el-table-column
              prop="responsibilityRemark"
              label="责任说明"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div
                  v-if="
                    claimantInfo.auditResultDisplay == '待正审' ||
                    $route.query.operate == '责任确定' ||
                    $route.query.operate == '编辑金额' ||
                    ($route.query.operate == '审核' &&
                      (claimantInfo.auditResultDisplay == '驳回(责任确定)' ||
                        claimantInfo.auditResultDisplay ==
                          '驳回(部长加签审批)'))
                  "
                >
                  <el-input
                    v-model="scope.row.responsibilityRemark"
                    placeholder="请输入"
                  ></el-input>
                </div>

                <span v-else>{{ scope.row.responsibilityRemark }}</span>
              </template>
            </el-table-column>
            <!-- 操作 -->
            <el-table-column prop="id" label="操作" min-width="180px">
              <template slot-scope="scope">
                <el-button
                  v-if="
                    claimantInfo.auditResultDisplay == '待正审' ||
                    $route.query.operate == '责任确定' ||
                    $route.query.operate == '编辑金额' ||
                    ($route.query.operate == '审核' &&
                      (claimantInfo.auditResultDisplay == '驳回(责任确定)' ||
                        claimantInfo.auditResultDisplay ==
                          '驳回(部长加签审批)'))
                  "
                  size="mini"
                  type="text"
                  @click="handleDeleteResponsibility(scope.$index)"
                >
                  删除</el-button
                >
                <el-button
                  size="mini"
                  type="text"
                  @click="handleEditData('供应商二赔金额填写', scope.row)"
                  v-if="
                    ($route.query.operate === '确认金额' ||
                      $route.query.operate === '编辑金额') &&
                    scope.row.responsibilityType == 2
                  "
                >
                  编辑</el-button
                >
                <el-button
                  size="mini"
                  type="text"
                  @click="handleEditData('供应商二赔金额填写记录', scope.row)"
                  v-if="
                    (claimantInfo.auditResultDisplay == '待结算' ||
                      claimantInfo.auditResultDisplay == '已结算') &&
                    scope.row.responsibilityType == 2
                  "
                >
                  历史记录</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 附件信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            附件信息
          </div>
        </div>
        <div class="form-container">
          <el-form-item label="附件信息">
            <div class="file">
              <div
                class="file-list"
                style="cursor: pointer"
                v-for="(data, idx) in claimantInfo.fileList"
                :key="idx"
              >
                <div class="left">
                  <i class="el-icon-document"></i
                  ><span>{{ data.fileName }}</span>
                </div>
                <div class="down-icon" v-if="data.downStatus">已下载</div>
                <div class="right" @click="downLoad(data.filePath, idx)">
                  下载
                </div>
                <div
                  class="right"
                  style="margin-left: 10px"
                  v-if="showViewBtn(data.fileType)"
                  @click="viewFile(data)"
                >
                  预览
                </div>
              </div>
            </div>
          </el-form-item>
        </div>
        <!-- 审核信息 -->
        <last-audit
          v-if="
            claimantInfo.claimStatementAudit &&
            (claimantInfo.claimStatementAudit.auditType ||
              claimantInfo.claimStatementAudit.auditType === 0) &&
            $route.query.operate == '查看详情'
          "
          :claimant="claimantInfo"
        />
      </el-form>
    </div>
    <div v-else class="record_info">
      <!-- 历史记录 -->
      <div class="hearder-title">
        <div class="flex_between">
          <img
            class="title-icon"
            src="@/assets/img/title-icon.svg"
            alt="dark"
          />
          历史记录
          <el-button
            style="margin-left: 20px"
            type="primary"
            size="mini"
            @click="handleViewRecord('detail')"
            >返回</el-button
          >
        </div>
      </div>
      <div class="form-container">
        <audit-record :recordList="recordList" />
      </div>
    </div>
    <view-img-video ref="viewRef" :list="previewList" />
    <!-- 供应商二赔金额填写 -->
    <second-compensation-dialog
      ref="secondCompensationDialogRef"
      @success="getResponsibilityList"
    />
  </div>
</template>

<script>
import Translate from "@/components/translate";
import TranslateAll from "@/components/translateAll";
import { getDictItem, getDictValueByCodeText, getDictValue } from "@/util/dict";
import AuditRecord from "./auditRecord.vue";
import {
  auditHistoryList,
  gysPriceFillOutdataList,
  getECPDataByVIN,
  getECPData,
  getResponsibilityListApi,
} from "@/api/seek";
import LastAudit from "./lastAudit.vue";
import ViewImgVideo from "@/components/viewImgVideo.vue";
import { getSession } from "@/util/localStor";
import CryptoJS from "crypto-js";
import HistoryResponsibilityDialog from "./historyResponsibilityDialog.vue";
import SecondCompensationDialog from "./secondCompensationDialog.vue";
import { hasAnyRole } from "@/utils/role";

export default {
  components: {
    Translate,
    TranslateAll,
    AuditRecord,
    LastAudit,
    ViewImgVideo,
    HistoryResponsibilityDialog,
    SecondCompensationDialog,
  },
  props: {
    claimantInfo: {
      type: Object,
      default: () => {},
    },
    showExamineBtn: {
      type: Boolean,
      default: true,
    },
    fieldsData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      responsibilityDepartmentListObj: {
        responsibilityPart1: [],
        responsibilityPart2: [],
        responsibilityPart3: [],
      }, // 责任部门列表对象
      vinOptions: [], // vin列表
      showfaultListError: false, // 其他故障件错误
      faultList: [], // EPC系统故障件数据
      previewList: [],
      partMajorList: [
        {
          name: "车身",
          id: 1,
        },
        {
          name: "底盘",
          id: 2,
        },
        {
          name: "电器",
          id: 3,
        },
        {
          name: "内外饰",
          id: 4,
        },
        {
          name: "新能源",
          id: 5,
        },
        {
          name: "动力",
          id: 6,
        },
      ], //零部件专业
      pageIndex: "detail", // 详情 | 记录
      responsibilityTypeList: [],
      recordList: [],
      dialogVisible: false,
      supplierList: {},
      loading: false,
      exchangeRate: 1, // 汇率
    };
  },
  watch: {
    "claimantInfo.fileList": {
      handler(newVal, oldVal) {
        if (newVal) {
          this.previewList = newVal?.filter((item) => {
            return "image,video".indexOf(item.fileType.slice(0, 5)) !== -1;
          });
        }
      },
    },
  },
  computed: {},
  async created() {
    this.previewList = this.claimantInfo.fileList?.filter((item) => {
      return "image,video".indexOf(item.fileType.slice(0, 5)) !== -1;
    });
    this.responsibilityTypeList = await getDictItem("responsibilityType");
    const res = await auditHistoryList({
      data: { claimStatementId: this.claimantInfo.claimStatementId },
    });
    this.recordList = res.data;

    // 获取内部责任部门列表
    this.getResponsibilityDepartmentList("responsibilityPart1");
    // 获取外部责任部门列表
    this.getResponsibilityDepartmentList("responsibilityPart2");
    // 获取海外事业部责任部门列表
    this.getResponsibilityDepartmentList("responsibilityPart3");

    if (
      this.claimantInfo.responsibilityPartList &&
      this.claimantInfo.responsibilityPartList.length > 0
    ) {
      this.claimantInfo.responsibilityPartList.map((item, index) => {
        this.getSupplierList(item, index);
      });
    }
  },
  async mounted() {
    await this.getExchangeRate();
    if (this.claimantInfo.repairPlan == 0) {
      // this.claimantInfo.sourceOfComponents = 0;
      // this.claimantInfo.changeQuantity = 0;
      // this.claimantInfo.faultPartsList?.map((item, index) => {
      //   item.sourceOfComponents = 0;
      //   item.changeQuantity = 0;
      //   item.faultPartTotalPrice = 0;
      //   item.laborCost = 0;
      //   item.materialCost = 0;
      //   this.getTotalPrice("fault", index);
      // });
      // this.$set(this.claimantInfo, "faultPartTotalPrice", 0);
      // this.$set(this.claimantInfo, "laborCost", 0);
      // this.$set(this.claimantInfo, "materialCost", 0);
      this.getTotalPrice("fault");
    }
  },
  methods: {
    getSession,
    getDictValueByCodeText,
    // 获取汇率
    async getExchangeRate() {
      const exchangeRateDict = await getDictItem("exchangeRate");
      const exchangeRateItem = getDictValue(exchangeRateDict, "USD/CNY");
      this.exchangeRate = exchangeRateItem?.codeText || this.exchangeRate;
    },
    // 判断字段是否禁用
    getDisabledField(value) {
      if (
        this.$route.query.operate === "编辑金额"
        // || this.$route.query.operate === "审核"
      ) {
        return false;
      }
      if (
        this.$route.query.operate === "查看详情" ||
        hasAnyRole(["章总", "OTS部部长"])
      ) {
        return true;
      }
      for (const key in this.fieldsData) {
        if (key == value) {
          return false;
        }
      }
      return true;
    },
    // 获取责任部门列表
    async getResponsibilityDepartmentList(field) {
      const responsibilityDepartmentList = await getDictItem(field);
      this.responsibilityDepartmentListObj[field] =
        responsibilityDepartmentList;
    },
    // 获取ECP接口参数
    getECPParams() {
      const appId = "586738eb-49ed-4289-b951-193bfee3452b";
      const authToken = "298714f9-b43c-4772-b259-e6e2728cbd91";
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now.getDate().toString().padStart(2, "0");
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = now.getMinutes().toString().padStart(2, "0");
      const seconds = now.getSeconds().toString().padStart(2, "0");
      const timestamp =
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
      // 拼接appId、authToken和timestamp三个参数后，进行MD5摘要得到16进制摘要字符串，然后转大写得到签名
      const concat = appId + authToken + timestamp;
      const sign = CryptoJS.MD5(concat).toString().toUpperCase();
      return { appId, timestamp, sign };
    },
    // 获取vin信息
    async vinRemoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        const { appId, timestamp, sign } = this.getECPParams();
        const params = {
          appId,
          timestamp,
          sign,
          vin: query,
          account: this.claimantInfo.customerAccountNum,
        };
        const res = await getECPDataByVIN(params);
        if (res.data) {
          this.loading = false;
          this.vinOptions = res.data;
          this.vinOptions?.map((item, i) => {
            if (item.vin == query) {
              this.$set(this.claimantInfo, "carBrand", item.brand);
              this.$set(this.claimantInfo, "carModel", item.model);
              this.$set(this.claimantInfo, "engineModel", item.engineModel);
              this.$set(this.claimantInfo, "productionDate", item.vinCreated);
            }
          });
        } else {
          this.loading = false;
          this.vinOptions = [];
          this.claimantInfo.vin = query;
          this.$set(this.claimantInfo, "carBrand", "");
          this.$set(this.claimantInfo, "carModel", "");
          this.$set(this.claimantInfo, "engineModel", "");
          this.$set(this.claimantInfo, "productionDate", "");
        }
      } else {
        this.vinOptions = [];
        this.$set(this.claimantInfo, "carBrand", "");
        this.$set(this.claimantInfo, "carModel", "");
        this.$set(this.claimantInfo, "engineModel", "");
        this.$set(this.claimantInfo, "productionDate", "");
      }
    },
    // vin 改变时获取车辆信息
    changeVin(val) {
      this.vinOptions?.map((item, i) => {
        if (item.vin == val) {
          this.$set(this.claimantInfo, "carBrand", item.brand);
          this.$set(this.claimantInfo, "carModel", item.model);
          this.$set(this.claimantInfo, "engineModel", item.engineModel);
          this.$set(this.claimantInfo, "productionDate", item.vinCreated);
        }
      });
    },
    // 根据发生日期获取预设数据
    async getPreSetData() {
      const res = await getPreset({
        data: {
          customerAccountNum: this.claimantInfo.customerAccountNum,
          happenDate: this.claimantInfo.happenDate,
        },
      });
      if (res.data) {
        this.$set(
          this.claimantInfo,
          "managementFeeRate",
          res.data.claimManagementRate
        );
        this.$set(this.claimantInfo, "hourlyRate", res.data.claimUnitPrice);
        this.$set(this.claimantInfo, "currency", res.data.currency);

        this.getTotalPrice("fault");

        this.$emit("update:happenDateError", false);
      } else {
        this.$set(this.claimantInfo, "managementFeeRate", undefined);
        this.$set(this.claimantInfo, "hourlyRate", undefined);
        this.$set(this.claimantInfo, "currency", undefined);
        this.$set(this.claimantInfo, "faultPartTotalPrice", undefined);
        this.$set(this.claimantInfo, "materialTotalCost", undefined);
        this.$emit("update:happenDateError", true);
      }
      this.$refs.form.validateField("happenDate");
    },
    // 修改维修方案
    changRepairPlan(val) {
      if (val == 0) {
        // this.claimantInfo.sourceOfComponents = 0;
        // this.claimantInfo.changeQuantity = 0;
        // this.claimantInfo.faultPartsList?.map((item, index) => {
        //   item.sourceOfComponents = 0;
        //   item.changeQuantity = 0;
        //   item.faultPartTotalPrice = 0;
        //   item.laborCost = 0;
        //   item.materialCost = 0;
        //   this.getTotalPrice("fault", index);
        // });
        this.$set(this.claimantInfo, "faultPartTotalPrice", 0);
        this.$set(this.claimantInfo, "laborCost", 0);
        this.$set(this.claimantInfo, "materialCost", 0);
      }
      this.getTotalPrice("fault");
    },
    // 判断ECP数据中是否存在该故障件
    async findFault() {
      const faultIndex = this.faultList.findIndex((item) => {
        return item.code === this.claimantInfo.faultPartNumber;
      });
      if (faultIndex === -1) {
        this.$set(this.claimantInfo, "faultPartNameZh", "");
        this.$set(this.claimantInfo, "faultPartName", "");
        this.$set(this.claimantInfo, "faultPartUnitPrice", "");
        this.getTotalPrice("fault");
        this.$emit("update:faultError", true);
      } else {
        this.$set(
          this.claimantInfo,
          "faultPartNameZh",
          this.faultList[faultIndex].name
        );
        this.$set(
          this.claimantInfo,
          "faultPartName",
          this.faultList[faultIndex][this.claimantInfo.languageType] ||
            this.faultList[faultIndex].en ||
            this.faultList[faultIndex].zh
        );
        this.$set(
          this.claimantInfo,
          "faultPartUnitPrice",
          this.claimantInfo.currency === 0
            ? (this.faultList[faultIndex].price * this.exchangeRate).toFixed(2)
            : this.faultList[faultIndex].price
        );
        this.getTotalPrice("fault");
        this.$emit("update:faultError", false);
      }
    },
    // 根据故障件件号，EPC系统获取故障件
    async getFault(queryString) {
      const { appId, timestamp, sign } = this.getECPParams();
      const params = {
        appId,
        timestamp,
        sign,
        codeList: [queryString],
        account: this.claimantInfo.customerAccountNum,
      };
      const res = await getECPData(params);
      const faultList = res.data;
      return faultList;
    },
    // 获取故障件列表
    async getFaultList(queryString, cb) {
      if (queryString && queryString.length >= 7) {
        const faultList = await this.getFault(queryString);
        this.faultList = [];
        faultList?.map((item) => {
          this.faultList.push({ ...item, zh: item.name, value: item.code });
        });
      } else {
        this.faultList = [];
      }
      cb(this.faultList);
    },
    // 输入故障件
    handleInput(ref) {
      this.$refs[ref].$refs.input.blur(); // 取消焦点
      this.$refs[ref].activated = false; // 关闭下拉框
    },
    // 表格输入故障件获取数据
    async onBlurFault(index) {
      if (this.faultList.length === 0) {
        const faultList = await this.getFault(
          index === 0 || index
            ? this.claimantInfo.faultPartsList[index].faultPartNumber
            : this.claimantInfo.faultPartNumber
        );
        this.faultList = [];
        faultList?.map((item) => {
          this.faultList.push({ ...item, zh: item.name, value: item.code });
        });
      }
      if (index === 0 || index) {
        if (!this.claimantInfo.faultPartsList[index].faultPartNumber) {
          this.claimantInfo.faultPartsList[index].error = undefined;
        } else {
          const faultIndex = this.faultList.findIndex((item) => {
            return (
              item.code ===
              this.claimantInfo.faultPartsList[index].faultPartNumber
            );
          });
          if (faultIndex === -1) {
            this.claimantInfo.faultPartsList[index].faultPartNameZh = "";
            this.claimantInfo.faultPartsList[index].faultPartName = "";
            this.claimantInfo.faultPartsList[index].faultPartUnitPrice = "";
            this.$set(this.claimantInfo.faultPartsList[index], "error", true);
            this.getTotalPrice("fault", index);
          } else {
            this.claimantInfo.faultPartsList[index].faultPartNameZh =
              this.faultList[faultIndex].name;
            this.claimantInfo.faultPartsList[index].faultPartName =
              this.faultList[faultIndex][this.claimantInfo.languageType] ||
              this.faultList[faultIndex].en ||
              this.faultList[faultIndex].zh;
            this.claimantInfo.faultPartsList[index].faultPartUnitPrice =
              this.claimantInfo.currency === 0
                ? (
                    this.faultList[faultIndex].price * this.exchangeRate
                  ).toFixed(2)
                : this.faultList[faultIndex].price;
            this.claimantInfo.faultPartsList[index].error = undefined;
            this.getTotalPrice("fault", index);
          }
        }
        this.showfaultListError =
          this.claimantInfo.faultPartsList.findIndex((item) => {
            return item.error === true;
          }) !== -1;
      } else {
        await this.findFault();
        this.$refs.form.validateField("faultPartNumber");
      }
    },
    // 选择故障件
    handleSelect(item, index) {
      if (index === 0 || index) {
        this.claimantInfo.faultPartsList[index].faultPartNameZh = item.name;
        this.claimantInfo.faultPartsList[index].faultPartName =
          item[this.claimantInfo.languageType] || item.en || item.zh;
        this.claimantInfo.faultPartsList[index].faultPartUnitPrice =
          this.claimantInfo.currency === 0
            ? (item.price * this.exchangeRate).toFixed(2)
            : item.price;
        this.claimantInfo.faultPartsList[index].error = undefined;
        this.showfaultListError =
          this.claimantInfo.faultPartsList.findIndex((item) => {
            return item.error === true;
          }) !== -1;
        this.getTotalPrice("fault", index);
      } else {
        this.$set(this.claimantInfo, "faultPartNameZh", item.name);
        this.$set(
          this.claimantInfo,
          "faultPartName",
          item[this.claimantInfo.languageType] || item.en || item.zh
        );
        this.$set(
          this.claimantInfo,
          "faultPartUnitPrice",
          this.claimantInfo.currency === 0
            ? (item.price * this.exchangeRate).toFixed(2)
            : item.price
        );
        this.getTotalPrice("fault");
        this.$emit("update:faultError", false);
      }
    },
    // 获取金额
    getTotalPrice(type, index) {
      // ====== 内联函数：计算单个故障件的各项费用 ======
      const calculateFaultPartTotal = (item, isMainFault = false) => {
        // 零部件来源 0=海外免费件 1=收费件 2=供应商免费件
        const sourceOfComponents = isMainFault
          ? this.claimantInfo.sourceOfComponents
          : item.sourceOfComponents;
        // 故障件单价
        const faultPartUnitPrice = isMainFault
          ? this.claimantInfo.faultPartUnitPrice
          : item.faultPartUnitPrice;
        // 更换数量
        const changeQuantity = isMainFault
          ? this.claimantInfo.changeQuantity
          : item.changeQuantity;
        // 管理费费率
        const managementFeeRate = isMainFault
          ? this.claimantInfo.managementFeeRate
          : item.managementFeeRate;
        // 工时
        const workingHours = isMainFault
          ? this.claimantInfo.workingHours || 0
          : item.workingHours || 0;
        // 维修方案 0=维修 1=更换 2=补发
        const repairPlan = isMainFault
          ? this.claimantInfo.repairPlan
          : item.repairPlan;
        // 运费
        const shippingFee = isMainFault
          ? this.claimantInfo.shippingFee || 0
          : item.shippingFee || 0;
        // 关税
        const tariff = isMainFault
          ? this.claimantInfo.tariff || 0
          : item.tariff || 0;
        // 其他费用
        const otherExpenses = isMainFault
          ? this.claimantInfo.otherExpenses || 0
          : item.otherExpenses || 0;
        // 差旅费
        const travelPrice = isMainFault
          ? this.claimantInfo.travelPrice || 0
          : item.travelPrice || 0;

        let materialCost = 0;
        // 只有更换或者补发的收费件才会有材料费
        if (repairPlan == 0 || sourceOfComponents != 1) {
          // 材料费 = 单价 × 数量 × (1 + 管理费费率)
          materialCost = 0;
        } else {
          const rawCost =
            faultPartUnitPrice * changeQuantity * (1 + managementFeeRate);
          materialCost = Math.round(rawCost + "e" + 2) / 100;
        }

        let laborCost;
        // 维修(0) 工时费 = 工时 × 工时单价
        if (repairPlan == 0) {
          const rawCost = workingHours * this.claimantInfo.hourlyRate;
          laborCost = Math.round(rawCost + "e" + 2) / 100;
          // 更换(1)/补发(2) 工时费 = 工时 × 数量 × 工时单价
        } else {
          const rawCost =
            workingHours * (changeQuantity || 0) * this.claimantInfo.hourlyRate;
          laborCost = Math.round(rawCost + "e" + 2) / 100;
        }
        // 故障件总价 = 工时费 + 材料费 + 运费 + 关税 + 其他费用 + 差旅费
        const rawCost =
          laborCost +
          materialCost +
          shippingFee +
          tariff +
          otherExpenses +
          travelPrice;
        const totalCost = Math.round(rawCost + "e" + 2) / 100;
        return { laborCost, materialCost, faultPartTotalPrice: totalCost };
      };

      // ====== 故障件费用计算(type === "fault") ======
      if (type === "fault") {
        // 有 index：计算指定其他故障件的费用
        if (index === 0 || index) {
          const { laborCost, materialCost, faultPartTotalPrice } =
            calculateFaultPartTotal(
              this.claimantInfo.faultPartsList[index],
              false
            );
          // 写入该其他故障件的各项费用
          this.claimantInfo.faultPartsList[index].laborCost = laborCost;
          this.claimantInfo.faultPartsList[index].materialCost = materialCost;
          this.claimantInfo.faultPartsList[index].faultPartTotalPrice =
            faultPartTotalPrice;
          // 无 index：计算主因故障件的费用
        } else {
          const { laborCost, materialCost, faultPartTotalPrice } =
            calculateFaultPartTotal(this.claimantInfo, true);
          // 写入主因故障件的各项费用
          this.$set(this.claimantInfo, "laborCost", laborCost);
          this.$set(this.claimantInfo, "materialCost", materialCost);
          this.$set(
            this.claimantInfo,
            "faultPartTotalPrice",
            faultPartTotalPrice
          );
        }

        // ====== 材料总费用汇总 ======
        if (
          this.claimantInfo.faultPartTotalPrice ||
          this.claimantInfo.faultPartTotalPrice === 0
        ) {
          let total = 0;
          // 主因故障件 - 收费件(1)和海外免费件(0)才计算材料费
          if (
            this.claimantInfo.sourceOfComponents == 1 ||
            this.claimantInfo.sourceOfComponents == 0
          ) {
            total = this.claimantInfo.materialCost || 0;
          }

          // 累加其他故障件的材料费
          this.claimantInfo.faultPartsList?.map((item) => {
            if (item.sourceOfComponents == 1 || item.sourceOfComponents == 0) {
              total += item.materialCost ? Number(item.materialCost) : 0;
            }
          });
          this.$set(
            this.claimantInfo,
            "materialTotalCost",
            Math.round(total + "e" + 2) / 100
          );
        } else {
          this.$set(this.claimantInfo, "materialTotalCost", 0);
        }

        // ====== 汇总各项费用的总费用 ======
        if (
          this.claimantInfo.faultPartsList.length > 0 ||
          this.claimantInfo.faultPartTotalPrice
        ) {
          // 以下变量用于汇总主因+其他故障件的各项费用
          let materialTotal = 0; // 材料费汇总
          let workingHoursTotal = 0; // 总工时(用于 manHour)
          let laborCostTotal = 0; // 工时费汇总
          let freightTotal = 0; // 运费汇总
          let tariffTotal = 0; // 关税汇总
          let otherTotal = 0; // 其他费用汇总
          let travelPriceTotal = 0; // 差旅费汇总
          let workingHourArr = []; // 存放每个故障件的工时(更换时*数量)

          // 主因故障件：累加其各项费用到汇总变量
          if (this.claimantInfo.faultPartTotalPrice) {
            // 主因故障件的工时：维修(0)不乘数量，更换(1)/补发(2)乘数量
            if (this.claimantInfo.repairPlan == 0) {
              workingHourArr.push(this.claimantInfo.workingHours || 0);
            } else {
              workingHourArr.push(
                (this.claimantInfo.workingHours || 0) *
                  (this.claimantInfo.changeQuantity || 0)
              );
            }

            // 累加主因故障件的各项费用
            materialTotal += this.claimantInfo.materialCost
              ? this.claimantInfo.materialCost
              : 0;
            laborCostTotal += this.claimantInfo.laborCost
              ? this.claimantInfo.laborCost
              : 0;
            freightTotal += this.claimantInfo.shippingFee
              ? this.claimantInfo.shippingFee
              : 0;
            tariffTotal += this.claimantInfo.tariff
              ? this.claimantInfo.tariff
              : 0;
            otherTotal += this.claimantInfo.otherExpenses
              ? this.claimantInfo.otherExpenses
              : 0;
            travelPriceTotal += this.claimantInfo.travelPrice
              ? this.claimantInfo.travelPrice
              : 0;
          }

          // 其他故障件：累加每个故障件的各项费用到汇总变量
          this.claimantInfo.faultPartsList?.map((item) => {
            // 每个故障件按自己的维修方案计算工时
            if (item.repairPlan !== 0) {
              let newWorkingHours = item.workingHours * item.changeQuantity;
              workingHourArr.push(newWorkingHours);
            } else {
              workingHourArr.push(item.workingHours);
            }
            // 累加该故障件的各项费用
            materialTotal += item.materialCost ? item.materialCost : 0;
            laborCostTotal += item.laborCost ? item.laborCost : 0;
            freightTotal += item.shippingFee ? item.shippingFee : 0;
            tariffTotal += item.tariff ? item.tariff : 0;
            otherTotal += item.otherExpenses ? item.otherExpenses : 0;
            travelPriceTotal += item.travelPrice ? item.travelPrice : 0;
          });
          // 总工时 = 所有故障件工时之和
          workingHoursTotal = workingHourArr.reduce(
            (accumulator, currentValue) => accumulator + currentValue,
            0
          );
          // 将汇总结果写入表单字段
          this.$set(this.claimantInfo, "materialTotalCost", materialTotal); // 材料总费用
          this.$set(this.claimantInfo, "manHour", workingHoursTotal); // 总工时
          this.$set(this.claimantInfo, "totalCostOfWork", laborCostTotal); // 工时总费用
          this.$set(this.claimantInfo, "freight", freightTotal); // 总运费
          this.$set(this.claimantInfo, "tariffTotal", tariffTotal); // 总关税
          this.$set(this.claimantInfo, "otherTotalCost", otherTotal); // 其他总费用
          this.$set(this.claimantInfo, "travelPriceTotal", travelPriceTotal); // 总差旅费
        } else {
          // 无故障件时各项费用清零
          this.$set(this.claimantInfo, "materialTotalCost", 0);
          this.$set(this.claimantInfo, "manHour", 0);
          this.$set(this.claimantInfo, "totalCostOfWork", 0);
          this.$set(this.claimantInfo, "freight", 0);
          this.$set(this.claimantInfo, "tariff", 0);
          this.$set(this.claimantInfo, "otherTotalCost", 0);
        }

        // ====== 费用信息字段变更时重新计算(type === "costOfWork") ======
      } else if (type === "costOfWork") {
        // 重新汇总所有故障件的工时费
        let laborCostTotal = this.claimantInfo.laborCost || 0;
        this.claimantInfo.faultPartsList?.map((item) => {
          laborCostTotal += item.laborCost ? item.laborCost : 0;
        });
        this.$set(
          this.claimantInfo,
          "totalCostOfWork",
          Math.round(laborCostTotal + "e" + 2) / 100
        );
        // ====== 仅重新计算主因故障件总价(type === "onlyWork") ======
      } else if (type === "onlyWork") {
        // 主因故障件总价 = 工时总费用 + 材料总费用 + 其他总费用 + 总运费 + 关税 + 差旅费
        this.$set(
          this.claimantInfo,
          "faultPartTotalPrice",
          Number(this.claimantInfo.totalCostOfWork) +
            Number(this.claimantInfo.materialTotalCost) +
            Number(this.claimantInfo.otherTotalCost) +
            Number(this.claimantInfo.freight) +
            Number(this.claimantInfo.tariff) +
            Number(this.claimantInfo.travelPrice)
        );
      }
      // ====== 计算索赔总费用(所有费用合计) ======
      // 判断条件：各项费用均已赋值(可能是0)
      if (
        (this.claimantInfo.totalCostOfWork ||
          this.claimantInfo.totalCostOfWork === 0) &&
        (this.claimantInfo.materialTotalCost ||
          this.claimantInfo.materialTotalCost === 0) &&
        (this.claimantInfo.otherTotalCost ||
          this.claimantInfo.otherTotalCost === 0) &&
        (this.claimantInfo.freight || this.claimantInfo.freight === 0) &&
        (this.claimantInfo.tariffTotal ||
          this.claimantInfo.tariffTotal === 0) &&
        (this.claimantInfo.travelPriceTotal ||
          this.claimantInfo.travelPriceTotal === 0)
      ) {
        // 索赔总费用 = 工时总费用 + 材料总费用 + 其他总费用 + 总运费 + 总关税 + 总差旅费
        this.$set(
          this.claimantInfo,
          "claimTotalCost",
          Number(this.claimantInfo.totalCostOfWork) +
            Number(this.claimantInfo.materialTotalCost) +
            Number(this.claimantInfo.otherTotalCost) +
            Number(this.claimantInfo.freight) +
            Number(this.claimantInfo.tariffTotal) +
            Number(this.claimantInfo.travelPriceTotal)
        );
      } else {
        this.$set(this.claimantInfo, "claimTotalCost", 0);
      }
    },
    // 获取供应商列表
    getSupplierList(row, index) {
      if (!row.faultPartNumber) return;
      gysPriceFillOutdataList({ faultPartNumber: row.faultPartNumber }).then(
        (res) => {
          if (res.status == 0) {
            this.$set(this.supplierList, index, res.data || []);
          }
        }
      );
    },
    // 打开二赔编辑弹窗
    handleEditData(title, data) {
      this.$refs.secondCompensationDialogRef.init(title, {
        ...data,
        mainFaultPartNumber: this.claimantInfo.faultPartNumber,
      });
    },
    // 详情 | 记录
    handleViewRecord(index) {
      this.pageIndex = index;
      this.$emit(
        "update:showExamineBtn",
        this.pageIndex === "detail" ? true : false
      );
    },
    // 获取翻译值
    getTranslateVal(field, value) {
      this.$set(this.claimantInfo, field, value);
    },
    // 历史责任
    handleHistoryResponsibility() {
      this.$refs.historyResponsibilityDialog.init(
        this.claimantInfo.claimStatementId
      );
    },
    // 添加责任主主体
    handleAddResponsibility() {
      if (!this.claimantInfo.responsibilityPartList) {
        this.$set(this.claimantInfo, "responsibilityPartList", []);
      }
      this.claimantInfo.responsibilityPartList.push({
        responsibilityDepartment: "", // 责任部门
        responsibilityType: "", // 责任类型
        faultPartNumber: "", // 责任故障件件号
        responsibilitySupplierCode: "", // 供应商代码
        responsibilitySupplier: "", // 供应商名称
        responsibilityRatio: undefined, // 责任占比
        currency: 0, // 货币单位
        firstDamages: "", // 初赔金额
        secondDamages: "", // 二赔金额
        responsibilityRemark: "", // 责任说明
      });
    },
    // 删除责任主主体
    handleDeleteResponsibility(index) {
      this.claimantInfo.responsibilityPartList.splice(index, 1);
    },
    // 责任类型改变
    responsibilityTypeChange(row, index) {
      this.claimantInfo.responsibilityPartList[index].faultPartNumber = ""; // 情况故障件
      if (row.responsibilityType == "1") {
        this.claimantInfo.responsibilityPartList[
          index
        ].responsibilityDepartment = "";
      } else if (row.responsibilityType == "2") {
        this.claimantInfo.responsibilityPartList[
          index
        ].responsibilityDepartment = "供应商";
      } else {
        this.claimantInfo.responsibilityPartList[
          index
        ].responsibilityDepartment = "海外事业部";
      }
    },
    // 责任部门改变
    responsibilityDepartmentChange(row, index) {
      this.claimantInfo.responsibilityPartList[index].responsibilitySupplier =
        "";
    },
    // 责任故障件件号改变
    responsibilityPartNumberChange(row, index) {
      [
        ...this.claimantInfo.faultPartsList,
        {
          faultPartNumber: this.claimantInfo.faultPartNumber,
          faultPartName: this.claimantInfo.faultPartNameZh,
        },
      ].map((item) => {
        if (item.faultPartNumber == row.faultPartNumber) {
          this.claimantInfo.responsibilityPartList[index].faultPartName =
            item.faultPartName;
        }
      });
      this.getSupplierList(row, index);
    },
    // 处理供应商代码输入框失去焦点的事件
    handleSupplierCodeBlur(row, index) {
      // 当代码是手动输入时，在这里清空自动填充的名称，避免混淆
      if (this.isManualSupplierCode(row.responsibilitySupplierCode, index)) {
        // 手动输入代码后，名称输入框为空
        // row.responsibilitySupplier = '';
      }
    },
    // 判断一个供应商代码是否是手动输入的（即不在预定义的supplierList中）
    isManualSupplierCode(code, index) {
      if (!code) return false;
      const list = this.supplierList[index] || [];
      // 检查code是否存在于当前行的供应商列表中
      return !list.some((item) => item.lifnr === code);
    },
    // 责任供应商代码改变
    responsibilitySupplierCodeChange(row, index) {
      const supplier = this.supplierList[index].find(
        (item) => item.lifnr === row.responsibilitySupplierCode
      );
      this.claimantInfo.responsibilityPartList[index].responsibilitySupplier =
        supplier?.name1;
      this.claimantInfo.responsibilityPartList[index].sapPrice =
        supplier?.kbetr;
    },
    // 下载
    downLoad(url, index) {
      this.$set(this.claimantInfo.fileList[index], "downStatus", true);
      window.open(url);
    },
    showViewBtn(type) {
      const fileExtension = type.slice(0, 5);
      return "image,video".indexOf(fileExtension) !== -1;
    },
    // 预览
    viewFile(data) {
      this.$refs.viewRef.init(data);
    },
    // 编辑后获取责任判定列表
    getResponsibilityList() {
      getResponsibilityListApi({
        claimStatementId: this.claimantInfo.claimStatementId,
      }).then((res) => {
        if (res.status === "0") {
          let newResponsibilityPartList = res.data || [];
          // 将二赔金额为空时处理，避免为空时显示0
          newResponsibilityPartList.map((item, index) => {
            newResponsibilityPartList[index].secondDamages =
              item.secondDamages ?? undefined;
          });
          this.claimantInfo.responsibilityPartList = newResponsibilityPartList;
        }
      });
    },
  },
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<style lang="scss" scoped>
.detail-container {
  padding-bottom: 20px;
  ::v-deep .el-table__body .el-input {
    width: unset;
  }
  ::v-deep .el-textarea__inner {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
      "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }
  .top-container {
    position: sticky;
    top: 0;
    z-index: 999;
    background-color: #fff;
    padding: 15px 32px 15px 14px;
    border-bottom: 5px solid #efefef;
    .split {
      margin: 0 10px 0 7px;
      border: 1px solid #dde0e8;
      height: 18px;
    }
  }
  .status-container {
    display: flex;
    align-items: baseline;
    padding: 13px 44px;
    border-bottom: 1px solid #dcdee0;
    .status {
      margin: 0 85px;
    }
    .btn {
      color: #4084ff;
      padding: 0;
      font-size: 16px;
    }
  }
  .hearder-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    .title-icon {
      margin-right: 10px;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .form-container {
    margin-top: 34px;
  }
  .second-title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
    padding: 22px 10px 10px 62px;
    border-bottom: 1px solid #dcdee0;
  }
  .tips {
    line-height: 20px;
    color: #cecece;
    font-size: 14px;
  }
  .err-nowarp {
    ::v-deep .el-form-item__error {
      white-space: nowrap;
    }
  }
  .table-container {
    .is-error {
      ::v-deep .el-input__inner {
        border-color: #f56c6c;
      }
    }
    ::v-deep .table-auto-input .el-input__inner {
      width: 250px;
    }

    .table-btn {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .text-btn {
        cursor: pointer;
        color: #4084ff;
        padding: 0;
        font-size: 14px;
      }
    }
  }
  .number-input {
    ::v-deep .el-input__inner {
      text-align: left;
    }
  }
  .daolei {
    height: 50px;
    display: flex;
    align-content: center;
    justify-content: center;
    line-height: 50px;
  }

  .is-error {
    color: #f56c6c;
    font-size: 12px;
  }
  .fanyi-box {
    padding-left: 50px;
    ::v-deep .el-textarea__inner {
      height: 100px;
    }
    .textAreaTipBtn {
      cursor: pointer;
      width: fit-content;
      color: #1890ff;
    }
  }
}
.file {
  .down-icon {
    margin-left: 10px;
    color: #1890ff;
  }
  .file-list {
    margin: 0 10px;
    padding: 0 5px;
    box-sizing: border-box;
    border-radius: 3px;
    display: flex;
    align-items: center;
    cursor: pointer;
    display: flex;
    i {
      font-size: 20px;
    }
    span {
      display: inline-block;
      font-size: 12px;
      margin-left: 5px;
    }
    .right {
      font-size: 12px;
      padding: 0 5px;
      border: 1px solid #4095e5;
      text-align: center;
      margin-left: 30px;
      border-radius: 6px;
      height: 26px;
      line-height: 26px;
      box-sizing: border-box;
      opacity: 0;
    }
  }
  .file-list:hover {
    background: rgb(243, 246, 249);
    color: #4095e5;
    .right {
      opacity: 1;
    }
  }
}
</style>
